var _defs, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _ellipse3, _ellipse4, _path5, _ellipse5, _ellipse6, _path6, _ellipse7, _ellipse8, _path7, _ellipse9, _ellipse10, _path8, _ellipse11, _ellipse12, _path9, _ellipse13, _ellipse14, _path10, _ellipse15, _ellipse16, _path11, _ellipse17, _ellipse18, _path12, _path13, _g, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _path14, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle3, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _ellipse23, _ellipse24, _rect32, _ellipse25, _ellipse26, _rect33, _ellipse27, _ellipse28, _rect34, _ellipse29, _ellipse30, _rect35, _ellipse31, _ellipse32, _rect36, _ellipse33, _ellipse34, _rect37, _ellipse35, _ellipse36, _rect38, _ellipse37, _ellipse38, _rect39, _ellipse39, _ellipse40, _rect40, _ellipse41, _ellipse42, _rect41, _ellipse43, _ellipse44, _rect42, _rect43, _ellipse45, _ellipse46, _rect44, _ellipse47, _ellipse48, _rect45, _ellipse49, _ellipse50, _rect46, _rect47, _ellipse51, _ellipse52, _rect48, _ellipse53, _ellipse54, _rect49, _ellipse55, _ellipse56, _rect50, _rect51, _ellipse57, _ellipse58, _rect52, _ellipse59, _ellipse60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 974,
    height: 714.52,
    viewBox: "0 0 974 714.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0716a939-3e70-42e2-b2a4-62d4623bb7b7-247",
    x1: 574.72,
    y1: 713.31,
    x2: 574.72,
    y2: 358.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "246fdb29-47ea-4475-84d7-0cdffd1436cc-248",
    x1: 2975.38,
    y1: 757.78,
    x2: 2975.38,
    y2: 205.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 3906, 0)",
    xlinkHref: "#0716a939-3e70-42e2-b2a4-62d4623bb7b7-247"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "make_it_rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.9,454.74c-12.81,3.87-24.8,13.24-28,26.24-3.66,14.94,4.78,30,6,45.34,3.94,50.26-67.56,85.72-57.36,135.09,4.05,19.63,20.42,34.07,36.55,46,25.84,19.05,54.51,35.88,86.26,40.63,48.19,7.22,98.54-14,145.38-.59,37.78,10.82,66.69,42.53,104.21,54.23,28.56,8.91,59.33,5.4,89,1.79,16-1.94,32.76-4.18,45.67-13.78,24-17.87,25.51-53.16,41.58-78.45,24.82-39,79.24-46.66,124.87-39.08S926,698.4,972.23,696.88c9.88-.33,20-1.67,28.62-6.52,10.48-5.89,17.56-16.27,23.82-26.54a429.45,429.45,0,0,0,62.27-213.39c.27-12.95-.19-26.46-6.28-37.89-7.7-14.46-23.09-23.11-38.41-28.93-36.79-14-77.43-16.29-113.48-32.08C894,336.3,865.84,309.59,835.56,286.7a496.49,496.49,0,0,0-204.49-91.07c-17.39-3.36-35.44-5.76-52.72-1.88-19.91,4.47-37.07,16.88-52.5,30.24-41.05,35.54-73.95,79.39-111.78,118.34a636.39,636.39,0,0,1-84.92,73.23c-14,10.09-28.88,22.07-44.48,29.53C270.39,451.91,257,450.19,241.9,454.74Z",
    transform: "translate(-113 -92.74)",
    fill: "#01bf71",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M424.88,138.88s-38.65,51.33-11,111.16S365.69,406,365.69,406",
    transform: "translate(-113 -92.74)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.21,119.67c-3.07,13.21-17.76,21.08-17.76,21.08s-9.7-13.55-6.63-26.76,11-22.65,17.76-21.08S445.28,106.46,442.21,119.67Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 429.54,
    cy: 116.72,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(105.49 415.88) rotate(-76.9)",
    fill: "#8ed16f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 429.54,
    cy: 116.72,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(105.49 415.88) rotate(-76.9)",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.53,178.36c-12.76,4.6-27.35-3.46-27.35-3.46s6.1-15.51,18.87-20.1,25-3,27.35,3.46S448.29,173.76,435.53,178.36Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.13,
    cy: 166.12,
    rx: 7.71,
    ry: 2.89,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -143.78, 63.15)",
    fill: "#8ed16f"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.13,
    cy: 166.12,
    rx: 7.71,
    ry: 2.89,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -143.78, 63.15)",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M432.56,225.13c-12.76,4.6-27.35-3.46-27.35-3.46s6.1-15.51,18.87-20.1,25-3,27.35,3.46S445.32,220.54,432.56,225.13Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.15,
    cy: 212.9,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(-159.81 64.91) rotate(-19.8)",
    fill: "#8ed16f"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.15,
    cy: 212.9,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(-159.81 64.91) rotate(-19.8)",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M447.47,280c-12.76,4.6-27.35-3.46-27.35-3.46s6.1-15.51,18.87-20.1,25-3,27.35,3.46S460.23,275.43,447.47,280Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.06,
    cy: 267.79,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(-177.52 73.21) rotate(-19.8)",
    fill: "#8ed16f"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.06,
    cy: 267.79,
    rx: 7.71,
    ry: 2.89,
    transform: "translate(-177.52 73.21) rotate(-19.8)",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.77,330.18c-12.76,4.6-27.35-3.46-27.35-3.46s6.1-15.51,18.87-20.1,25-3,27.35,3.46S450.54,325.59,437.77,330.18Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.37,
    cy: 317.95,
    rx: 7.71,
    ry: 2.89,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -195.09, 72.89)",
    fill: "#8ed16f"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.37,
    cy: 317.95,
    rx: 7.71,
    ry: 2.89,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -195.09, 72.89)",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.92,191.65c9.42,9.76,26.07,9,26.07,9s1.37-16.61-8.05-26.37-21.09-13.78-26.07-9S368.5,181.89,377.92,191.65Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.28,
    cy: 182.62,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-131.18 227.49) rotate(-43.99)",
    fill: "#8ed16f"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.28,
    cy: 182.62,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-131.18 227.49) rotate(-43.99)",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M372.51,346.64c9.42,9.76,26.07,9,26.07,9s1.37-16.61-8.05-26.37-21.09-13.78-26.07-9S363.09,336.88,372.51,346.64Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.86,
    cy: 337.61,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-240.35 267.22) rotate(-43.99)",
    fill: "#8ed16f"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.86,
    cy: 337.61,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-240.35 267.22) rotate(-43.99)",
    opacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M385,246.43c12.14,6.06,27.57-.24,27.57-.24s-4.25-16.11-16.38-22.17-24.48-6-27.57.24S372.86,240.37,385,246.43Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.8,
    cy: 234.8,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-106.8 386.88) rotate(-63.48)",
    fill: "#8ed16f"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.8,
    cy: 234.8,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-106.8 386.88) rotate(-63.48)",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M390.09,301c12.14,6.06,27.57-.24,27.57-.24s-4.25-16.11-16.38-22.17-24.48-6-27.57.24S378,295,390.09,301Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.9,
    cy: 289.38,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-152.82 421.65) rotate(-63.48)",
    fill: "#8ed16f"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.9,
    cy: 289.38,
    rx: 2.89,
    ry: 7.71,
    transform: "translate(-152.82 421.65) rotate(-63.48)",
    opacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.73,249.21s70.59,70.59,30.74,175.34,68.31,278.94,68.31,278.94-1.16-.17-3.31-.55c-145-25.59-217-191.41-136.4-314.59C228,342.55,252.65,288.83,238.73,249.21Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113,534.72s80.55-12.83,87.89,59.36,154.89,82.2,154.89,82.2-1,.66-2.77,1.84c-121.83,80-238.29,50.94-220.74-55.25C138.81,583.38,138.27,543.73,113,534.72Z",
    transform: "translate(-113 -92.74)",
    fill: "#8ed16f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113,534.72s80.55-12.83,87.89,59.36,154.89,82.2,154.89,82.2-1,.66-2.77,1.84c-121.83,80-238.29,50.94-220.74-55.25C138.81,583.38,138.27,543.73,113,534.72Z",
    transform: "translate(-113 -92.74)",
    fill: "#fff"
  }))), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.34,
    cy: 383.3,
    rx: 22.15,
    ry: 57.79,
    fill: "#8ed16f"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.34,
    cy: 383.3,
    rx: 22.15,
    ry: 57.79,
    opacity: 0.3
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.81,
    cy: 662.42,
    rx: 14.93,
    ry: 33.23,
    transform: "translate(-524.92 237.62) rotate(-45)",
    fill: "#8ed16f"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.81,
    cy: 662.42,
    rx: 14.93,
    ry: 33.23,
    transform: "translate(-524.92 237.62) rotate(-45)",
    opacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M836.89,358.2H312.55a23.89,23.89,0,0,0-23.89,23.89V689.42a23.89,23.89,0,0,0,23.89,23.89H836.89a23.89,23.89,0,0,0,23.89-23.89V382.09A23.89,23.89,0,0,0,836.89,358.2Z",
    transform: "translate(-113 -92.74)",
    fill: "url(#0716a939-3e70-42e2-b2a4-62d4623bb7b7-247)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 269.64,
    width: 558.65,
    height: 346.75,
    rx: 24.81,
    ry: 24.81,
    fill: "#01bf71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 330.32,
    width: 558.65,
    height: 63.57,
    fill: "#01bf71"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 330.32,
    width: 558.65,
    height: 63.57,
    opacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235.37,
    y: 441.09,
    width: 452.7,
    height: 30.82,
    fill: "#d6d6e3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272.93,
    cy: 548.97,
    r: 44.31,
    fill: "#01bf71"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.93,
    cy: 548.97,
    r: 44.31,
    opacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M822.28,276.88a9.7,9.7,0,0,0,4.27,5.4c9.19,6.07,29.17,4.78,31.57,4.78.51,0,1.18.91,1.92,2.44,3.53,7.28,9,28.62,9.37,33.42.49,5.81,5.89,33,14.73,43.13.27.31.54.6.8.87,8.67,8.71,18.84-.87,18.84-.87l1.46-5.07c-.41,2-.87,4.33-1.33,6.94-.23,1.31-.46,2.7-.68,4.13a158.29,158.29,0,0,0-2.07,24.37,88.41,88.41,0,0,0,.38,8.88c.08.82.17,1.63.28,2.42a84.78,84.78,0,0,1,.66,10.84c-.08,21.52-5.57,48.29-5.57,48.29l.21-.07c-.13.67-.21,1-.21,1l.32-.1q-.23,1.49-.44,3.05c-1.86,13.5-2.93,30.3-3.44,40a80.1,80.1,0,0,0,.68,15.32l9.76,68.71v32a56.5,56.5,0,0,0,1.76,14.38c3.18,12.09.56,54.29-.91,74.31-.41,5.46-.73,9.28-.82,10.38l0,.33.28-.11c0,.23,0,.35,0,.35a5.65,5.65,0,0,1,1.3-.38c-3.87,6-10.88,15.92-16.27,17.59A17.07,17.07,0,0,0,881,749l-.14.19-.2.28a6,6,0,0,0-1.17,3.06,3.38,3.38,0,0,1-.18-.59c-.41,2.23.93,4.27,5.14,5.26a34.6,34.6,0,0,0,7.45.6c14.6,0,40.51-4.49,43.37-9.32V731.82l.47.15,0,.15,1.79.59,4.91-16.48c5.89-4.36,1-82.39,0-100.32-.9-16.34,9.21-81.34,11-92.79l-.24-.29.27-1.67a7.11,7.11,0,0,1,1,.88A13.07,13.07,0,0,1,956,524.3a30.22,30.22,0,0,1,2.17,4.48c9.88,24.64,14.33,95.1,14.33,101.42v66.26a69,69,0,0,0,2.7,19.33,82.91,82.91,0,0,1,2.1,10.06c.21,1.33.39,2.65.56,3.91s.34,2.7.47,3.88c0,.31.07.61.1.89s0,.27,0,.41c.27,2.61.41,4.32.41,4.32a1,1,0,0,1,.2-.39l.05.63a1.35,1.35,0,0,1,.39-.62,9.47,9.47,0,0,1,1.32-1.08v8.42l-.24-.18v1.45c10.18,7.68,26.75,10,39.47,9.91,8.25,0,14.93-1,17.25-2.16,3.32-1.63,1.5-5.43-1.52-8.34-2.34-2.26-5.39-4-7.32-3.78-3.22.35-14.23-12.12-20-18.95l.65-.29.92-.4V613s1.48-43.62,5.89-86.76a153.48,153.48,0,0,0-7.55-64.36l-.14-.41,1.34.21c1.42.22,2.18.35,2.18.35s0-.34-.09-1h.09s-1.72-18.71-1.74-42.21c0-26.64,2.25-59.12,11.56-77.5,5.36-10.58,7.15-19,7-25.64a26.82,26.82,0,0,0-4.79-16.4,13,13,0,0,0-5.51-4.36l-.19-.11h-.1a13.7,13.7,0,0,0-5.06-1H992.79a13.43,13.43,0,0,1-6.64-1.75l-7.87-4.46c-2.62-5.73-3-12.83-2.44-19.49,0-.53.1-1.06.15-1.58l.57-.6c.44-.47.85-1,1.25-1.45a11.15,11.15,0,0,1-.09,1.18c-.1.63-.27,1-.54,1.08,4.3-.56,9.1-1.41,11.74-4.73.11-.13.21-.27.31-.41a21.43,21.43,0,0,0,1.93-4,11.62,11.62,0,0,1,1.47-2.68c.66-.86,1.52-1.56,2.23-2.38l.12-.14c2.53-3,2.67-7.3,2.7-11.22.05-9.52-.23-20-6.6-27.14-5.29-5.94-13.73-8.19-21.74-8.45s-16,1.18-24,1.22c-5.44,0-12-.09-15,4.41-1.47,2.21-1.65,5.1-3.25,7.22-.92,1.22-2.33,2.27-2.41,3.79a3.89,3.89,0,0,0,.52,2l0,.07c1.94,3.82,6.06,6.2,10.36,6.95a25.81,25.81,0,0,0-2,2.76,26.28,26.28,0,0,0-4,14c0,.58,0,1.15.06,1.72A26.43,26.43,0,0,0,938,267.34c-.08.56-.16,1.12-.25,1.67l.18.16q.85.77,1.77,1.46l.22.17c0,.35,0,.7,0,1,0,.58,0,1.17-.06,1.74s0,.92-.06,1.38l-.13-.11-9.77-8.16-15.71-14.54s-39.28-28.59-41.25-15a9.79,9.79,0,0,0,1.87,6.78c7.21,11,32,20.36,32,20.36s14.78,15.63,24.67,32.48c-.35.19-.7.37-1.07.54-8.8,4.09-21.64,2.36-21.64,2.36-14.83,2.31-16.17,18.56-16.09,25.13,0,.31,0,.61,0,.88s0,.33,0,.48L873,279.91l-.06-.14a9.73,9.73,0,0,0-7.36-5.78C852.42,271.78,819.53,267.17,822.28,276.88Zm82.39,449a8.57,8.57,0,0,1,.87-.16l-.09.14Z",
    transform: "translate(-113 -92.74)",
    fill: "url(#246fdb29-47ea-4475-84d7-0cdffd1436cc-248)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1003,716.43s18.64,23.43,22.95,22.95,14.34,9.08,8.61,12-38.72,4.78-55-7.65V725Z",
    transform: "translate(-113 -92.74)",
    fill: "#aca9c9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M908.81,717.86s-11,19.6-18.64,22-14.34,11-4.3,13.39,45.9-2.87,49.24-8.61V719.29Z",
    transform: "translate(-113 -92.74)",
    fill: "#aca9c9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M895,525.31l9.5,67.78V624.6a56.48,56.48,0,0,0,1.72,14.18c3.1,11.93.55,53.55-.89,73.3-.47,6.44-.83,10.56-.83,10.56,6.21-2.87,32.51,6.21,32.51,6.21l2.66-9.05,2.12-7.2c5.74-4.3,1-81.27,0-99-.65-12.11,4.75-51.37,8.21-74.9,1-6.65,1.81-12,2.3-15.22.31-2,.48-3.11.48-3.11a10.47,10.47,0,0,1,2.58,3.11,29.93,29.93,0,0,1,2.11,4.42c9.62,24.31,14,93.81,14,100v65.36a68.92,68.92,0,0,0,2.63,19.07,100,100,0,0,1,2.59,13.77c.68,5.19,1,9.37,1,9.37.48-2.87,30.12-15.78,30.12-15.78v-109s1.43-43,5.74-85.58a152.68,152.68,0,0,0-5.5-57.58c-1.19-4.07-2.38-7.52-3.41-10.25-1.75-4.65-3-7.22-3-7.22H904c-1.64.31-3,3.61-4.23,8.62-.8,3.36-1.5,7.48-2.11,12-1.81,13.31-2.85,29.88-3.35,39.46A79.86,79.86,0,0,0,895,525.31Z",
    transform: "translate(-113 -92.74)",
    fill: "#618fd8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1006.09,720V611s1.43-43,5.74-85.58-12-75.06-12-75.06h1.91s16.25,32.51,12,75.06S1008,611,1008,611V720s-29.64,12.91-30.12,15.78c0,0,0-.64-.15-1.74C984.19,729.55,1006.09,720,1006.09,720Z",
    transform: "translate(-113 -92.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.37,722.34a7.42,7.42,0,0,0-2.63.54l0-.48A17.06,17.06,0,0,1,907.37,722.34Z",
    transform: "translate(-113 -92.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.12,712.84c5.74-4.3,1-81.27,0-99s11-93.22,11-93.22a8.34,8.34,0,0,1,1.65,1.7c-1.76,11.28-11.6,75.41-10.73,91.52,1,17.69,5.74,94.66,0,99l-4.78,16.25-1.74-.58Z",
    transform: "translate(-113 -92.74)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M914.54,332.05l-10,35.38s-10.52,10-19.12,0S871.52,330.62,871,324.88s-8.13-35.38-11-35.38-31.55,1.91-34.9-10c-2.68-9.58,29.34-5,42.16-2.85a9.5,9.5,0,0,1,7.17,5.7l19.66,46.95S904.5,317.23,914.54,332.05Z",
    transform: "translate(-113 -92.74)",
    fill: "#f7c4a7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M979.08,249.82s-12.43,34.9,3.35,47.33S926,312.93,926,312.93l9.8-9.32s6.93-27.49,2.15-50.44Z",
    transform: "translate(-113 -92.74)",
    fill: "#f7c4a7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M963.78,297.15s12.67-3.11,12.67-6.45l11.23,6.45h28.21s20.56,11.47,3.35,45.9-9.56,119-9.56,119-61.19-11-111.87,5.74c0,0,7.65-37.77,4.78-59.28s4.78-51.63,4.78-51.63l4.3-18.17s-.24-17-17.93-8.37c0,0-2.63-24.62,15.54-27.49,0,0,21,2.87,27.25-7.65C936.53,295.24,950.4,303.37,963.78,297.15Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M963.78,296.2s12.67-3.11,12.67-6.45l8.23,4.73a13,13,0,0,0,6.46,1.72h19.73a13,13,0,0,1,10.57,5.38c4.53,6.37,8.59,18.93-2.2,40.52-17.21,34.42-9.56,119-9.56,119s-61.19-11-111.87,5.74c0,0,7.65-37.77,4.78-59.28S907.37,356,907.37,356l4.3-18.17s-.24-17-17.93-8.37c0,0-2.56-23.94,14.79-27.36A4.9,4.9,0,0,1,910,302c3.71.39,21,1.64,26.54-7.73C936.53,294.28,950.4,302.41,963.78,296.2Z",
    transform: "translate(-113 -92.74)",
    fill: "#e14b5a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.07,339.7s-15.3,9.56-40.16,0c0,0-27.25-10-35.86-29.64s43.5,3.35,43.5,3.35,11,0,14.34-2.39S1020.67,329.18,1012.07,339.7Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.07,337.79s-15.3,9.56-40.16,0c0,0-27.25-10-35.86-29.64S907.37,267,907.37,267s-34.9-13.39-33-26.77,40.16,14.82,40.16,14.82l15.3,14.34,49.72,42.07s11,0,14.34-2.39S1020.67,327.27,1012.07,337.79Z",
    transform: "translate(-113 -92.74)",
    fill: "#f7c4a7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M937.49,254.6l41.11-3.35a94.37,94.37,0,0,0-4.29,19.47,26.27,26.27,0,0,1-36.8,1A46.73,46.73,0,0,0,937.49,254.6Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.9,
    cy: 158.28,
    r: 26.29,
    fill: "#f7c4a7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M970.33,256.73c-1.54-2.54,1.59-5.85.56-8.63-.95-2.56-4.73-3-6-5.39-1-1.93,0-4.3-.4-6.43-.57-2.75-3.53-4.46-6.34-4.6s-5.52.91-8.19,1.81c-4.35,1.47-8.93,2.6-13.49,2.08s-9.11-3-11.14-7.07a4,4,0,0,1-.51-1.94c.08-1.5,1.46-2.53,2.35-3.73,1.56-2.09,1.74-4.94,3.16-7.12,2.9-4.44,9.27-4.33,14.57-4.35,7.8,0,15.56-1.46,23.36-1.2s16,2.47,21.17,8.33c6.2,7.05,6.48,17.37,6.43,26.77,0,3.87-.16,8.08-2.63,11.07-.72.87-1.6,1.59-2.29,2.48-1.5,2-1.9,4.56-3.31,6.59-2.5,3.61-7.38,4.49-11.73,5.07,1.28-.17.22-8.74,0-9.53C975.06,257,974.15,257.08,970.33,256.73Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M970.33,255.78c-1.54-2.54,1.59-5.85.56-8.63-.95-2.56-4.73-3-6-5.39-1-1.93,0-4.3-.4-6.43-.57-2.75-3.53-4.46-6.34-4.6s-5.52.91-8.19,1.81c-4.35,1.47-8.93,2.6-13.49,2.08s-9.11-3-11.14-7.07a4,4,0,0,1-.51-1.94c.08-1.5,1.46-2.53,2.35-3.73,1.56-2.09,1.74-4.94,3.16-7.12,2.9-4.44,9.27-4.33,14.57-4.35,7.8,0,15.56-1.46,23.36-1.2s16,2.47,21.17,8.33c6.2,7.05,6.48,17.37,6.43,26.77,0,3.87-.16,8.08-2.63,11.07-.72.87-1.6,1.59-2.29,2.48-1.5,2-1.9,4.56-3.31,6.59-2.5,3.61-7.38,4.49-11.73,5.07,1.28-.17.22-8.74,0-9.53C975.06,256,974.15,256.12,970.33,255.78Z",
    transform: "translate(-113 -92.74)",
    fill: "#281c1c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.83,340.9s-12.91-33.47-22.95-34.42,19.12,0,19.12,0l9.56,17.21Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.79,340.9s-12.91-33.47-22.95-34.42,19.12,0,19.12,0l9.56,17.21Z",
    transform: "translate(-113 -92.74)",
    fill: "#e14b5a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M976.65,726.18c.68,5.19,1,9.37,1,9.37.48-2.87,30.12-15.78,30.12-15.78V712a13.18,13.18,0,0,0-2.26.11c-5.75.77-11.08,3.56-16,6.54A145.93,145.93,0,0,1,976.65,726.18Z",
    transform: "translate(-113 -92.74)",
    fill: "#618fd8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M976.65,726.18c.68,5.19,1,9.37,1,9.37.48-2.87,30.12-15.78,30.12-15.78V712a13.18,13.18,0,0,0-2.26.11c-5.75.77-11.08,3.56-16,6.54A145.93,145.93,0,0,1,976.65,726.18Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M904.5,722.64c6.21-2.87,32.51,6.21,32.51,6.21l2.66-9.05c-4.59-.93-9.15-2.09-13.63-3.47a45.34,45.34,0,0,1-6.12-2.26,41,41,0,0,0-4.08-1.9c-3.43-1.18-7-.68-10.52-.09C904.86,718.52,904.5,722.64,904.5,722.64Z",
    transform: "translate(-113 -92.74)",
    fill: "#618fd8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M904.5,722.64c6.21-2.87,32.51,6.21,32.51,6.21l2.66-9.05c-4.59-.93-9.15-2.09-13.63-3.47a45.34,45.34,0,0,1-6.12-2.26,41,41,0,0,0-4.08-1.9c-3.43-1.18-7-.68-10.52-.09C904.86,718.52,904.5,722.64,904.5,722.64Z",
    transform: "translate(-113 -92.74)",
    opacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.3,749.89a2.86,2.86,0,0,0,1.64-1.9,2.81,2.81,0,0,1-1.64,3.33c-5.74,2.87-38.72,4.78-55-7.65v-1.43C995.58,754.67,1028.56,752.76,1034.3,749.89Z",
    transform: "translate(-113 -92.74)",
    fill: "#fff",
    opacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M885.62,751.8c10,2.39,45.9-2.87,49.24-8.61v1.43c-3.35,5.74-39.2,11-49.24,8.61-4.1-1-5.41-3-5-5.19C880.94,749.66,882.44,751,885.62,751.8Z",
    transform: "translate(-113 -92.74)",
    fill: "#fff",
    opacity: 0.4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M943.94,403.53s-10.52-3.35-13.39,0-27.4,11.2-27.4,11.2",
    transform: "translate(-113 -92.74)",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 271.1,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 450.53) rotate(-180)",
    fill: "#8ed16f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 272.17,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 452.68) rotate(-180)",
    fill: "#8ed16f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 272.17,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 452.68) rotate(-180)",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 273.25,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 454.84) rotate(-180)",
    fill: "#8ed16f"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 274.33,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 456.99) rotate(-180)",
    fill: "#8ed16f"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 274.33,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 456.99) rotate(-180)",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 275.4,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 459.14) rotate(-180)",
    fill: "#8ed16f"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 276.48,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 461.29) rotate(-180)",
    fill: "#8ed16f"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 276.48,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 461.29) rotate(-180)",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 277.55,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 463.44) rotate(-180)",
    fill: "#8ed16f"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 278.63,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 465.59) rotate(-180)",
    fill: "#8ed16f"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 278.63,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 465.59) rotate(-180)",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 262.49,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 433.32) rotate(-180)",
    fill: "#8ed16f"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 855.5,
    y: 253.41,
    width: 51.15,
    height: 1.08,
    transform: "translate(1283.12 919.84) rotate(-140.25)",
    fill: "#8ed16f"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 819.64,
    y: 236.2,
    width: 51.15,
    height: 1.08,
    transform: "translate(1230.7 866.47) rotate(-140.25)",
    fill: "#8ed16f"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 263.57,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 435.47) rotate(-180)",
    fill: "#8ed16f"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 263.57,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 435.47) rotate(-180)",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 264.64,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 437.63) rotate(-180)",
    fill: "#8ed16f"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 265.72,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 439.78) rotate(-180)",
    fill: "#8ed16f"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 265.72,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 439.78) rotate(-180)",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 266.8,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 441.93) rotate(-180)",
    fill: "#8ed16f"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 267.87,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 444.08) rotate(-180)",
    fill: "#8ed16f"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 267.87,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 444.08) rotate(-180)",
    opacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 268.95,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 446.23) rotate(-180)",
    fill: "#8ed16f"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 270.02,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 448.38) rotate(-180)",
    fill: "#8ed16f"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 824.9,
    y: 270.02,
    width: 51.15,
    height: 1.08,
    transform: "translate(1587.96 448.38) rotate(-180)",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 821.56,
    y: 278.75,
    width: 18.64,
    height: 36.33,
    transform: "translate(1480.61 647.76) rotate(-169.48)",
    fill: "#8ed16f"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 831.11,
    cy: 296.96,
    rx: 7.65,
    ry: 3.82,
    transform: "translate(274.45 967.17) rotate(-79.48)",
    fill: "#8ed16f"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 831.11,
    cy: 296.96,
    rx: 7.65,
    ry: 3.82,
    transform: "translate(274.45 967.17) rotate(-79.48)",
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 824.7,
    y: 354.13,
    width: 18.64,
    height: 36.33,
    transform: "translate(1473.07 797.84) rotate(-169.48)",
    fill: "#8ed16f"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 834.25,
    cy: 372.34,
    rx: 7.65,
    ry: 3.82,
    transform: "translate(202.89 1031.88) rotate(-79.48)",
    fill: "#8ed16f"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 834.25,
    cy: 372.34,
    rx: 7.65,
    ry: 3.82,
    transform: "translate(202.89 1031.88) rotate(-79.48)",
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 757.49,
    y: 201.78,
    width: 18.64,
    height: 36.33,
    transform: "translate(95.43 696.93) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 766.7,
    cy: 220.15,
    rx: 3.82,
    ry: 7.65,
    transform: "matrix(0.48, -0.88, 0.88, 0.48, 95.18, 696.94)",
    fill: "#8ed16f"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 766.7,
    cy: 220.15,
    rx: 3.82,
    ry: 7.65,
    transform: "matrix(0.48, -0.88, 0.88, 0.48, 95.18, 696.94)",
    opacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 687.34,
    y: 525.31,
    width: 18.64,
    height: 36.33,
    transform: "translate(-225.88 804.78) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 696.55,
    cy: 543.69,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-226.12 804.8) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 696.55,
    cy: 543.69,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-226.12 804.8) rotate(-61.58)",
    opacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 644.41,
    y: 258.32,
    width: 18.64,
    height: 36.33,
    transform: "translate(-13.56 627.11) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.62,
    cy: 276.69,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-13.8 627.12) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.62,
    cy: 276.69,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-13.8 627.12) rotate(-61.58)",
    opacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 698.21,
    y: 201.78,
    width: 18.64,
    height: 36.33,
    transform: "translate(64.36 644.79) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.42,
    cy: 220.15,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(64.12 644.8) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.42,
    cy: 220.15,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(64.12 644.8) rotate(-61.58)",
    opacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 733.11,
    y: 270.67,
    width: 18.64,
    height: 36.33,
    transform: "translate(-140.01 -10.27) rotate(-6.24)",
    fill: "#8ed16f"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 742.19,
    cy: 288.87,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-140.02 -10.3) rotate(-6.24)",
    fill: "#8ed16f"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 742.19,
    cy: 288.87,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-140.02 -10.3) rotate(-6.24)",
    opacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 860.17,
    y: 468.42,
    width: 18.64,
    height: 36.33,
    transform: "translate(-160.77 4.72) rotate(-6.24)",
    fill: "#8ed16f"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 869.25,
    cy: 486.61,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-160.77 4.7) rotate(-6.24)",
    fill: "#8ed16f"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 869.25,
    cy: 486.61,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-160.77 4.7) rotate(-6.24)",
    opacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 679.37,
    y: 345.22,
    width: 18.64,
    height: 36.33,
    transform: "translate(-71.67 703.39) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.57,
    cy: 363.6,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-71.92 703.4) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.57,
    cy: 363.6,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-71.92 703.4) rotate(-61.58)",
    opacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 598.74,
    y: 322.19,
    width: 18.64,
    height: 36.33,
    transform: "translate(-93.67 620.41) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.95,
    cy: 340.56,
    rx: 3.82,
    ry: 7.65,
    transform: "matrix(0.48, -0.88, 0.88, 0.48, -93.91, 620.42)",
    fill: "#8ed16f"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.95,
    cy: 340.56,
    rx: 3.82,
    ry: 7.65,
    transform: "matrix(0.48, -0.88, 0.88, 0.48, -93.91, 620.42)",
    opacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 572.92,
    y: 709.89,
    width: 18.64,
    height: 36.33,
    transform: "translate(-448.18 800.89) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 582.13,
    cy: 728.27,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-448.43 800.9) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 582.13,
    cy: 728.27,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-448.43 800.9) rotate(-61.58)",
    opacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 554.27,
    y: 711.81,
    width: 18.64,
    height: 36.33,
    transform: "translate(-369.92 1058.26) rotate(-79.49)",
    fill: "#8ed16f"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 554.27,
    y: 711.81,
    width: 18.64,
    height: 36.33,
    transform: "translate(-369.92 1058.26) rotate(-79.49)",
    opacity: 0.05
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.55,
    cy: 730.21,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-370.18 1058.41) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.55,
    cy: 730.21,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-370.18 1058.41) rotate(-79.49)",
    opacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 557.62,
    y: 722.8,
    width: 18.64,
    height: 36.33,
    transform: "translate(-377.99 1070.54) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.9,
    cy: 741.2,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-378.26 1070.69) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.9,
    cy: 741.2,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-378.26 1070.69) rotate(-79.49)",
    opacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 610.61,
    y: 757.01,
    width: 18.64,
    height: 36.33,
    transform: "translate(-469.87 858.73) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.82,
    cy: 775.39,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-470.11 858.74) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.82,
    cy: 775.39,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-470.11 858.74) rotate(-61.58)",
    opacity: 0.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 591.97,
    y: 758.92,
    width: 18.64,
    height: 36.33,
    transform: "translate(-385.42 1133.84) rotate(-79.49)",
    fill: "#8ed16f"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 591.97,
    y: 758.92,
    width: 18.64,
    height: 36.33,
    transform: "translate(-385.42 1133.84) rotate(-79.49)",
    opacity: 0.05
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.25,
    cy: 777.32,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-385.69 1133.99) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.25,
    cy: 777.32,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-385.69 1133.99) rotate(-79.49)",
    opacity: 0.1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 595.31,
    y: 769.92,
    width: 18.64,
    height: 36.33,
    transform: "translate(-393.5 1146.12) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 604.59,
    cy: 788.32,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-393.76 1146.27) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 604.59,
    cy: 788.32,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-393.76 1146.27) rotate(-79.49)",
    opacity: 0.1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 667.15,
    y: 726.65,
    width: 18.64,
    height: 36.33,
    transform: "translate(-413.53 892.54) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.36,
    cy: 745.02,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-413.78 892.55) rotate(-61.58)",
    fill: "#8ed16f"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.36,
    cy: 745.02,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-413.78 892.55) rotate(-61.58)",
    opacity: 0.1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 648.51,
    y: 728.56,
    width: 18.64,
    height: 36.33,
    transform: "translate(-309.34 1164.61) rotate(-79.49)",
    fill: "#8ed16f"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 648.51,
    y: 728.56,
    width: 18.64,
    height: 36.33,
    transform: "translate(-309.34 1164.61) rotate(-79.49)",
    opacity: 0.05
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.79,
    cy: 746.96,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-309.61 1164.76) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.79,
    cy: 746.96,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-309.61 1164.76) rotate(-79.49)",
    opacity: 0.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 651.85,
    y: 739.55,
    width: 18.64,
    height: 36.33,
    transform: "translate(-317.41 1176.89) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 661.13,
    cy: 757.96,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-317.68 1177.04) rotate(-79.49)",
    fill: "#8ed16f"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 661.13,
    cy: 757.96,
    rx: 3.82,
    ry: 7.65,
    transform: "translate(-317.68 1177.04) rotate(-79.49)",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg-5.e4b99782cfe24959a38c953a724b4056.svg";
export { ForwardRef as ReactComponent };